import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: {
        Gold:[],
        Prod:[],
    },
    loading: false,
    error: null,
    version: '',
};

const statusGraphSlice = createSlice({
    name: 'status',
    initialState,
    reducers: {
        fetchStatusRequest: (state,acion) => {
            state.loading = true;
            // state.error = action.payload;
        },
        fetchStatusSuccess: (state, action) => {            
            state.loading = false;
            state.data.Gold= action.payload;
            state.data.Prod= action.payload;
            state.version = action.payload.version;            
        },
        fetchStatusFailure: (state, action) => {
            state.loading =false;
            state.error = action.payload;
        },
    },
});

export const {fetchStatusRequest, fetchStatusSuccess, fetchStatusFailure} = statusGraphSlice.actions;

export default statusGraphSlice.reducer;